// Centralized store instance for non-hook access
import configStore from "./configStore";

// Create the store instance
export const store = configStore();
